'use client';

import React from 'react';
import ServiceHero from './ServiceHero';
import KeyFeatures from './KeyFeatures';
import TechnicalSpecs from './TechnicalSpecs';
import ImplementationProcess from './ImplementationProcess';
import SuccessMetrics from './SuccessMetrics';
import PricingSection from './PricingSection';
import ClientTestimonials from './ClientTestimonials';
import RelatedServices from './RelatedServices';
import FAQSection from './FAQSection';
import CTASection from './CTASection';

interface ServiceDetailData {
  service: {
    title: string;
    subtitle: string;
    description: string;
    icon: string;
    category: string;
  };
  features: Array<{
    icon: string;
    title: string;
    description: string;
  }>;
  specifications: Array<{
    category: string;
    items: string[];
  }>;
  processSteps: Array<{
    phase: string;
    title: string;
    description: string;
    duration: string;
    icon: string;
  }>;
  metrics: Array<{
    label: string;
    value: string;
    change: string;
    icon: string;
  }>;
  chartData: Array<{
    name: string;
    before: number;
    after: number;
  }>;
  pricingTiers: Array<{
    name: string;
    price: string;
    period: string;
    description: string;
    features: string[];
    highlighted: boolean;
  }>;
  testimonials: Array<{
    quote: string;
    author: string;
    role: string;
    company: string;
    image: string;
    alt: string;
    rating: number;
  }>;
  relatedServices: Array<{
    title: string;
    description: string;
    icon: string;
    href: string;
  }>;
  faqs: Array<{
    question: string;
    answer: string;
  }>;
}

interface ServiceDetailInteractiveProps {
  data: ServiceDetailData;
}

const ServiceDetailInteractive = ({ data }: ServiceDetailInteractiveProps) => {
  return (
    <>
      <ServiceHero service={data.service} />
      <KeyFeatures features={data.features} />
      <TechnicalSpecs specifications={data.specifications} />
      <ImplementationProcess steps={data.processSteps} />
      <SuccessMetrics metrics={data.metrics} chartData={data.chartData} />
      <PricingSection tiers={data.pricingTiers} />
      <ClientTestimonials testimonials={data.testimonials} />
      <RelatedServices services={data.relatedServices} />
      <FAQSection faqs={data.faqs} />
      <CTASection />
    </>
  );
};

export default ServiceDetailInteractive;